import { theme } from 'src/styles/themes/default'
import styled from '@emotion/styled'

export const SectionNewsletterPromocoes = styled.section`
  background: ${(props) =>
    props.darkTheme
      ? 'linear-gradient(180deg, #0250b5 -4.51%, #141723 104.58%)'
      : (props) =>
          props.initialColor
            ? `linear-gradient(85.36deg, ${props.initialColor} 3.91%, ${props.finalColor} 98.18%)`
            : 'linear-gradient(85.36deg, #5c33ff 3.91%, #3399FF 98.18%)'};
`

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.625rem 0;
  max-width: 81.875rem;
  width: 100%;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: 30rem) {
    flex-direction: column;
    align-items: center;
    padding: 1.375rem 1.25rem;
  }

  .texto {
    h2 {
      font: bold 1.375rem/1.6875rem 'Inter';
      color: ${(props) => props.textColor || theme.colors.white};
      margin-bottom: 0.125rem;
    }
    p {
      font-weight: 500;
      font-size: 1rem;
      line-height: 1.6875rem;
      color: ${(props) => props.textColor || theme.colors.white};
    }
  }
  form {
    display: flex;
    flex: 1;
    gap: 1.5rem;
    align-items: center;
    justify-content: space-between;
    max-width: 52.375rem;
    input[type='text'],
    input[type='email'] {
      width: 19.25rem;
      height: 3.375rem;
      background-color: #ffffff;
      border: 0.0625rem solid #dcdde3;
      box-sizing: border-box;
      border-radius: 0.375rem;
      font-size: 0.875rem;
      padding: 0rem 1.5rem;
      color: #363843;
      transition: all 0.3s;
      &:focus {
        border: 0.0625rem solid #0d71f0;
        transition: all 0.3s;
      }
      &::placeholder {
        color: #a0a4b3;
        transition: all 0.3s;
      }
    }
    button {
      border: 0.125rem solid
        ${(props) => props.buttonColor || theme.secondary.main};
      background-color: ${(props) => props.buttonColor || theme.secondary.main};
      border-radius: 0.375rem;
      width: 10.875rem;
      height: 3.375rem;
      color: ${(props) => props.textColor || theme.colors.white};
      letter-spacing: -0.0071rem;
      font-weight: 600;
      font-size: 0.875rem;
      text-transform: uppercase;
      transition: all 0.3s;
      &:hover {
        background-color: transparent;
        color: ${(props) => props.buttonColor || theme.secondary.main};
        transition: all 0.3s;
      }
    }
  }

  @media (max-width: 30rem) {
    .texto {
      h2 {
        font-size: 1.125rem;
        line-height: 1.6875rem;
        margin-bottom: 0.5rem;
        text-align: center;
      }
      p {
        text-align: center;
        margin-bottom: 1rem;
        font-size: 0.875rem;
        line-height: 1.3125rem;
      }
    }
    form {
      flex-direction: column;
      gap: 1rem;
      width: 100%;
      input[type='text'],
      input[type='email'] {
        width: 100%;
      }
      button {
        width: 100%;
      }
    }
  }
`
